import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
import { commaFormatted } from '../../../utils/transformer.util';
import { Button } from '../../../components/base/index';
import PengisianNilaiPsikForm from './components/PengisianNilaiPsikForm.component';
import NilaiPsikTable from './components/NilaiPsikTable.component';

export default class PengisianNilaiPsik extends PureComponent {
  constructor(props) {
    super(props);
    this._onFormChange = this._onFormChange.bind(this);
    this._onClickNext = this._onClickNext.bind(this);
    this.state = {
      form: {
        value: {},
        error: {},
      },
    };
  }

  _onFormChange(event) {
    const {
      name,
      value,
      dataset,
      files,
    } = event.target;
    const { inputType = 'text' } = dataset;
    this.setState((prevState) => {
      let formattedValue = value;
      if (inputType === 'number') {
        formattedValue = commaFormatted(value);
      }
      if (inputType === 'file') {
        [formattedValue] = files;
      }
      return {
        form: {
          value: {
            ...prevState.form.value,
            [name]: formattedValue,
          },
          error: {
            ...prevState.form.error,
            [name]: '',
          },
        },
      };
    });
  }

  _onClickNext() {
    const { history } = this.props;
    history.push('/dashboard/kesiswaan/laporan/daftar-siswa-kelas-unit');
  }


  render() {
    const { form } = this.state;
    return (

      <div className="student-list">
        <div className="budget__title">
          <h1>Pengisian Nilai PSIK / Keterampilan </h1>
          <hr />
        </div>
        <form onSubmit={this._onSubmit}>

          <div className="result__content">
            <PengisianNilaiPsikForm
              form={form}
              onFormChange={this._onFormChange}
            />
          </div>

          <NilaiPsikTable
            form={form}
            onFormChange={this._onFormChange}
          />

          <div className="manage-registration__footer">
            <Button
              onClick={this._onClickSubmit}
              title="Simpan Data"
            />
          </div>
        </form>
      </div>

    );
  }
}
PengisianNilaiPsik.propTypes = {
  handleGetKlapper: PropTypes.func,
  handleDeleteKlapper: PropTypes.func,
};
PengisianNilaiPsik.defaultProps = {
  handleGetKlapper: noop,
  handleDeleteKlapper: noop,
};
